<template>
	<transition name="modal-transition">
		<div v-if="local_value">
			<div class="aup-modal-wrapper position-fixed h-100 w-100">
				<div
						class="position-fixed aup-modal-backdrop"
						:style="{ backgroundImage: 'url(' + modalBgUrl + ')' }"
						@click="$emit('close')"
				></div>

				<div class="aup-modal position-relative">
					<div class="mb-3 align-self-end">
						<BaseButton
								class="ml-auto"
								:filled="true"
								border="round"
								color="black"
								@click="$emit('close')"
								aria-label="Close">
							<IconClose />
						</BaseButton>
					</div>
					<div class="aup-modal-content-wrapper d-flex flex-column aup-video-container" :class="{ 'tiktok': videoOptions.videoProvider == 'TikTok' }">
						<div v-html="embedHtml">
						</div>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>

	let body = document.body;

	export default {
		name: 'BaseModalVideo',

		computed: {
			embedHtml: {
				get() {
					switch (this.videoOptions.videoProvider) {
						case 'YouTube':
							//TODO need to add prod/dev switch for cookietuber
							return `<iframe  src="https://cookietuber.com/embed/${this.videoOptions.videoId}?feature=oembed&rel=0&modestbranding=1&autoplay=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
						case 'TikTok':
							//TODO need to implement cookieTuber for TikTok when it is ready BJJ 2022-04-13
							return `<iframe style="display: block; visibility: unset;" src="https://www.tiktok.com/embed/v2/${this.videoOptions.videoId}?lang=en-US"></iframe>`;
						case 'Vimeo':
							return  `<iframe src="https://player.vimeo.com/video/${this.videoOptions.videoId}?dnt=1"  frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen title=""></iframe>`;
						default:
							console.error(`Unknown video provider: ${this.videoOptions.videoProvider} `);
							return "";
					}
				},
			}

		},
		props: {
			modalBgUrl: {
				type: String,
				default: null,
			},
			showModal: {
				type: Boolean,
				default: false,
			},
			value: {
				type: Boolean,
				default: false,
			},
			videoOptions: {
				type: Object,
				required: true,
				default: () => {},
			},
			videoUrl: {
				type: String,
				default: '',
			}

		},
		watch: {
			value(val) {
				this.local_value = val;
			},
			local_value(val) {
				this.toggleBodyFixed();
				this.$emit('input', val);
			},
		},
		data() {
			return {
				local_value: this.value,
			};
		},
		methods: {
			toggleBodyFixed() {
				if (this.local_value) {
					document.body.style.overflow = "hidden";
				} else {
					document.body.style.overflow = "auto";
				}
			},
		},
	};
</script>

<style lang="scss">
	@import '../../assets/scss/all.scss';

	.aup-modal-open {
		overflow: hidden;
	}

	.aup-modal-backdrop {
		opacity: 1 !important;
		left: -5vw;
		background-position: 50% 50%;
		background-repeat: no-repeat;
		background-size: cover;
		filter: blur(20px) brightness(50%);
		backdrop-filter: blur(20px);
		width: 110vw;
		height: 100%;
		transform: scale(1.2);
		background-color: rgba(0, 0, 0, 0.3);
		transition: opacity 0.3s ease;
	}

	.aup-modal-wrapper {
		z-index: map-get($zindices, modal);
		position: fixed;
		top: 0;
		left: 0;
		overflow-y: scroll;
		cursor: default;
	}

	.aup-modal-content-wrapper {
		margin-left: auto;
		margin-right: auto;
		margin-bottom: 5rem;
		width: 80vw;
		max-width: 1160px;
		@include media-breakpoint-down(md) {
			width: 100%;
			padding: 24px 5%;
		}
	}
	.aup-modal-content-wrapper.tiktok {
		height: 740px;
		width: 330px;
		padding:0;
	}

	.aup-modal {
		z-index: map-get($zindices, popover);
		margin: $navbar-height auto 0;
		@include media-breakpoint-down(md) {
			margin: 0 auto;
		}
		left: 0;
		overflow-y: auto;
		max-width: 1160px;
	}

	// TODO: get transitions working
	.modal-transition-enter {
		opacity: 0;
	}

	.modal-transition-leave-active {
		opacity: 0;
	}

	.modal-transition-enter .aup-modal,
	.modal-transition-leave-active .aup-modal {
		-webkit-transform: scale(1.1);
		transform: scale(1.1);
	}
	.aup-video-container {
		position: relative;
		padding-bottom: 56.25%;
	}
	.aup-video-container iframe, blockquote {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}
	.aup-video-container.tiktok iframe {
		right: 0;
		bottom: 0;
		border: none;
		border-radius: 8px;
	}
</style>
